export default __webpack_public_path__ + "static/media/alvaro-team.555b628b.png";